import styled from "styled-components";
const SIZES = {
    SUB_MENU_WIDTH: 300
};
export default {
    SidebarSubMenu: styled.div.attrs({
        className: "bg-modal border modal-padding with-gap-xs unselectable"
    }) `
    width: ${SIZES.SUB_MENU_WIDTH}px;
    display: grid;
    grid-template-rows: auto auto 1fr auto;
  `
};
